// Real wedding details for Chithra Raj & Vishnu Vijayan.
export const COUPLE = {
  title: "ചിങ്ങത്തിൽ താലികെട്ട്",
  bride: {
    name: "Chithra",
    parents: "D/o Mr. Raju Raman & Mrs. Shila Krishnan",
    // WebP is ~86% smaller; the PNG stays as a fallback for pre-2020 browsers.
    imgWebp: "/assets/w82xr2pt_bride.webp",
    img: "/assets/w82xr2pt_bride.png",
  },
  groom: {
    name: "Vishnu",
    parents: "S/o Late Vijayan T. K. & Mrs. Bindu Vijayan",
    // WebP is ~86% smaller; the PNG stays as a fallback for pre-2020 browsers.
    imgWebp: "/assets/8089wh0g_groom.webp",
    img: "/assets/8089wh0g_groom.png",
  },
  hashtag: "#ChithraWedsVishnu",
  savingDate: "Sunday, 13 September 2026",
  invitation:
    "Two hearts, one journey. Come bless us with your presence as we begin our forever.",
};

const MAP_URL = "https://maps.app.goo.gl/woz3V9Vjyu4Ydxi36";

export const WEDDING_EVENT = {
  title: "The Wedding",
  malayalam: "വിവാഹം",
  ritual: "Subha Muhurtham",
  date: "Sunday, 13 September 2026",
  time: "11:50 AM – 12:20 PM",
  venue: "Michael Plaza Convention Centre",
  address: "Ramapuram, Kerala",
  mapUrl: MAP_URL,
};

export const RECEPTION_EVENT = {
  title: "The Reception",
  malayalam: "സ്‌നേഹവിരുന്ന്",
  date: "Monday, 14 September 2026",
  time: "6:30 PM onwards",
  venue: "Michael Plaza Convention Centre",
  address: "Ramapuram, Kerala",
  mapUrl: MAP_URL,
};

// Buffet "stations" shown on the reception board.
export const BUFFET_STATIONS = [
  { name: "Welcome Drinks", note: "Sambharam · Nannari · Tender Coconut" },
  { name: "Live Sadhya Counter", note: "Avial · Olan · Kaalan · Sambar" },
  { name: "Biryani & Grills", note: "Thalassery Biryani · Kozhi Porichathu" },
  { name: "Payasam Bar", note: "Ada Pradhaman · Palada · Semiya" },
];
